// A tiny observable for the loader's shell state. The loader writes it;
// Shell.jsx renders it.
import { useEffect, useState } from 'preact/hooks';

export function createStore(initial) {
  let state = initial;
  const listeners = new Set();
  return {
    get: () => state,
    set(patch) {
      const next = typeof patch === 'function' ? patch(state) : patch;
      state = { ...state, ...next };
      for (const fn of listeners) fn(state);
    },
    subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
  };
}

export function useStore(store) {
  const [s, set] = useState(store.get());
  useEffect(() => {
    const off = store.subscribe(set);
    set(store.get());
    return off;
  }, [store]);
  return s;
}
